import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import * as _ from 'lodash';

const FavouriteTrips = ({ data, allTripsPdf, allUnits, allowedKeys }) => {
    return (
        <Document>
            <Page style={styles.body}>
                <View style={styles.mainContainer}>
                    <View style={styles.flexWidth25}>
                        <View>
                            {data?.transit_agency?.logo ? (
                                <Image src={data?.transit_agency?.logo} style={{ maxWidth: 100, maxHeight: 100 }} />
                            ) : (
                                <Text>No image available</Text>
                            )}
                        </View>
                    </View>
                    <View style={styles.flexWidth75}>
                        <View style={styles.mainContainer}>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Name</Text>
                                <Text style={styles.subtitle}>{data?.name}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Transit Type</Text>
                                <Text style={styles.subtitle}>{_.capitalize(data?.transit_type)}</Text>
                            </View>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Total Retailers</Text>
                                <Text style={styles.subtitle}>{data?.noOfVendors}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Total Stations</Text>
                                <Text style={styles.subtitle}>{data?.noOfStations}</Text>
                            </View>

                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Length of Route</Text>
                                <Text style={styles.subtitle}>
                                    {data?.length} {allUnits.distanceUnit}
                                </Text>
                            </View>
                            <View style={styles.flexWidth20}>
                                <Text style={styles.title}>Daily Average Commuters</Text>
                                <Text style={styles.subtitle}>{Math.ceil(data?.avgDailyCommuter)}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View>
                    <View style={{ ...styles.mainContainer, ...styles.backgroundHeading }}>
                        {Object.keys(allowedKeys || {}).map((key, index) => {
                            return (
                                <Text style={{ ...styles.subtitle, ...styles.flexwidthRow(allowedKeys), ...styles.textWhite, ...styles.textCenter(index) }}>{key}</Text>
                            );
                        })}
                    </View>
                    <View style={{ ...styles.mainContainer }}>
                        {allTripsPdf.map((dataObj) => {
                            return (
                                <>
                                    {Object.values(allowedKeys || {}).map((key, index) => {
                                        return (
                                            <Text style={{ ...styles.subText, ...styles.flexwidthRow(allowedKeys), ...styles.textCenter(index), ...styles.tableDataRow }}>
                                                {typeof dataObj?.[key] === 'object' ? dataObj?.[key]?.name : dataObj?.[key]}
                                            </Text>
                                        );
                                    })}
                                </>
                            );
                        })}
                    </View>
                </View>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
            </Page>
        </Document>
    );
};

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    flexWidth25: {
        width: '25%',
        flexBasis: '25%',
        marginBottom: 10,
        textAlign: 'center'
    },
    flexGrow1: {
        flexGrow: 1
    },
    flexwidthRow: (allowedKeys) => {
        return {
            flexBasis:
                Object.keys(allowedKeys)?.length === 6 ? String(100 / Object.keys(allowedKeys)?.length - 1) + '%' : String(100 / Object.keys(allowedKeys)?.length) + '%'
        };
    },
    tableDataRow: {
        padding: 10,
        borderBottom: '1px solid #e0e0e0'
    },
    textCenter: (index) => ({
        textAlign: index === 0 ? 'start' : 'center'
    }),
    textStart: {
        textAlign: 'start'
    },
    backgroundHeading: {
        backgroundColor: '#13aa61',
        padding: 10
    },
    textWhite: {
        color: 'white'
    },
    flexWidth20: {
        width: '33.3%',
        flexBasis: '33%',
        marginBottom: 20,
        textAlign: 'center'
    },
    flexWidth75: {
        width: '75%',
        flexBasis: '75%',
        marginBottom: 20
    },
    dataBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: '1px solid #d3d3d3',
        borderRadius: '10px',
        padding: '5px',
        width: '250px',
        height: 'auto',
        margin: '5px'
    },
    textualData: {
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        marginLeft: '10px'
    },
    title: {
        fontSize: 14,
        textAlign: 'start',
        fontFamily: 'Oswald'
    },
    subtitle: {
        fontSize: 12,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold',
        textAlign: 'start'
    },
    subText: {
        fontSize: 10,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold',
        textAlign: 'start'
    },

    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },
    image: {
        width: 100,
        height: 100
    },
    header: {
        fontSize: 18,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
        fontWeight: 'semibold'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    }
});

export default FavouriteTrips;
